"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailSchema = exports.iProductBrandSchema = exports.iProductPageSchema = exports.iProductPageAttachmentSchema = exports.iProductPageContentSchema = exports.iProductPageHeadlineSchema = exports.iProductPageDisplaySchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
const PromotionMisc = __importStar(require("../misc/promotion"));
//Product Page Display
exports.iProductPageDisplaySchema = zod_1.z.object({
    item: zod_1.z.enum(['video', 'image']),
    url: zod_1.z.string(), // if image, URL after uploading to s3, else video URL
});
//Product Page Headline
exports.iProductPageHeadlineSchema = zod_1.z.array(zod_1.z.string());
//Product Page Content
exports.iProductPageContentSchema = zod_1.z.object({
    subheading: zod_1.z.string(),
    content: zod_1.z.string(),
});
//Product Page Attachment
exports.iProductPageAttachmentSchema = zod_1.z.object({
    title: zod_1.z.string(),
    url: zod_1.z.string(), // URL after uploading to s3
});
//Product Page
exports.iProductPageSchema = zod_1.z.object({
    display: exports.iProductPageDisplaySchema,
    headline: exports.iProductPageHeadlineSchema,
    content: zod_1.z.array(exports.iProductPageContentSchema),
    attachment: zod_1.z.array(exports.iProductPageAttachmentSchema)
});
//Product Brand
exports.iProductBrandSchema = zod_1.z.object({
    name: zod_1.z.string(),
    tokenId: zod_1.z.string(),
    externalIds: TokenMisc.ExternalIdsSchema
});
//Product Token
exports.ProductDetailSchema = zod_1.z.object({
    externalIds: TokenMisc.ExternalIdsSchema,
    status: PromotionMisc.StatusEnum,
    archive: zod_1.z.boolean(),
    templateType: zod_1.z.string(),
    name: zod_1.z.string(),
    brand: TokenMisc.ExternalIdsSchema,
    story: PromotionMisc.StorySchema,
    pages: zod_1.z.array(exports.iProductPageSchema),
    batch: zod_1.z.array(zod_1.z.string()).optional()
});
